<!-- Sales Code Items on Sales Code Modal  -->
<div class="sales-code-assignment-wrapper flex-column">
    <div class="sales-code-assignment-info flex-column" *ngFor="let service of services; let idx = index;">
        <!-- Service header -->
        <div class="sales-service-header flex-between-center">
            <span class="service-title capitalize">{{service?.title || service?.titleFR}}</span>
            <span class="unassigned-count flex-start-center" *ngIf="!assignedSalesCodeItems?.length">
                <i class="far fa-info-circle"></i>
                <span>{{service?.items?.length}}&nbsp;{{service?.items?.length > 1 ? 'items' :
                    'item'}}&nbsp;Unassigned</span>
            </span>
            <span class="unassigned-count flex-start-center"
                *ngIf="assignedSalesCodeItems?.length && service?.unassignedItemsCount">
                <i class="far fa-info-circle"></i>
                <span>{{service?.unassignedItemsCount}}&nbsp;{{service?.unassignedItemsCount > 1 ? 'items' :
                    'item'}}&nbsp;Unassigned</span>
            </span>
        </div>

        <!-- service body -->
        <div class="sales-service-body flex-column" *ngIf="type === 'sales-code'">
            <div class="unassigned-item flex-between-center"
                *ngFor="let item of service?.items; let itemIndex = index;">
                <div class="unassigned-item-info flex-column">
                    <span class="item-type-badge flex-start">
                        <i class="flex-start-center far " [ngClass]="iconMap[item?.type]"></i>
                        <span class="capitalize font-600">{{typeMap[item?.type]}}</span>
                    </span>
                    <span class="item-title font-14 font-600">{{item?.title}}</span>
                    <span class="item-classification font-14 font-400"
                        *ngIf="item?.itemClassificationTitle">Classification: {{item?.itemClassificationTitle}}</span>
                    <span class="item-classification font-14 font-400" *ngIf="!item?.itemClassificationTitle">No
                        Classification</span>
                </div>
                <div class="sales-code-info" [ngClass]="{'assigned': item?.salesCode?.title}">
                    <i>{{item?.salesCode?.title || 'Sales Code Unassigned'}}</i>
                </div>
            </div>
        </div>


        <div class="sales-service-body flex-column" *ngIf="type === 'warranty'">
            <div class="unassigned-item flex-between-center"
                *ngFor="let item of service?.items; let itemIndex = index;">
                <div class="unassigned-item-info d-flex">
                    <span class="item-type-badge flex-start">
                        <i class="flex-start-center far " [ngClass]="iconMap[item?.type]"></i>
                        <span class="capitalize font-600">{{typeMap[item?.type]}}s</span>
                    </span>
                    <span class="item-title font-14 font-600">{{item?.title || item?.titleFR}}</span>
                    <span class="item-classification font-14 font-400">
                        Part # {{item?.code || 'N/A'}}
                    </span>
                </div>
                <div class="sales-code-info assigned" *ngIf="getWarrantyLabel(item?.warranty)">
                    <i>
                        {{getWarrantyLabel(item?.warranty)}}
                    </i>
                </div>
            </div>
        </div>
    </div>
</div>